module.exports = __webpack_public_path__ + "img/category_main_348.82e69dc8.jpg";